export function relationFilter () {
    return (url, collection, fieldName) => {
        return (url && collection[url] && collection[url][fieldName]) || "";
    };
}



// WEBPACK FOOTER //
// ./sources/filters/relations.js